"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./_");
var invariant_1 = require("./invariant");
var METHODS = ['next', 'prev', 'first', 'last'];
function validateList(list) {
    if (process.env.NODE_ENV !== 'production') {
        METHODS.forEach(function (method) {
            return invariant_1.default(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method');
        });
    }
}
exports.validateList = validateList;
function notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
exports.notify = notify;
function instanceId(component, suffix) {
    if (suffix === void 0) { suffix = ''; }
    component.__id || (component.__id = _1.uniqueId('vdl_'));
    return (component.props.id || component.__id) + suffix;
}
exports.instanceId = instanceId;
function isFirstFocusedRender(component) {
    return component._firstFocus || (component.state.focused && (component._firstFocus = true));
}
exports.isFirstFocusedRender = isFirstFocusedRender;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/widget-helpers.js
// module id = 18
// module chunks = 0 1 2 3 4 5 6